/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import 'aisztheme';
import 'animate.css/animate.min.css';

import React from 'react';
import CSSModules from 'react-css-modules';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Link } from 'react-router';
import {
  FormattedMessage,
  injectIntl,
} from 'react-intl';
import isNil from 'lodash/isNil';
import {
  Form,
  FormControl,
  InputGroup,
  FormGroup,
  Button,
  Collapse,
} from 'react-bootstrap';
import HideIf from 'loracoms/HideIf';
import ShowIf from 'loracoms/ShowIf';
import RichButton from 'loracoms/RichButton';
import authActions from 'loraactions/auth';
import accountActions from 'loraactions/account';
import IntlMsg from 'lorautils/intl/IntlMsg';
import styles from './styles.scss';

const propTypes = {
  login: React.PropTypes.func.isRequired,
  logout: React.PropTypes.func.isRequired,
  reactivate: React.PropTypes.func.isRequired,
  intl: React.PropTypes.object.isRequired,
  authed: React.PropTypes.bool.isRequired,
  gotoOverview: React.PropTypes.func.isRequired,
  gotoRegister: React.PropTypes.func.isRequired,
  gotoLostPassword: React.PropTypes.func.isRequired,
  reactivated: React.PropTypes.object.isRequired,
};

class Login extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      username: '',
      password: '',
      reactivated: props.reactivated,
    };
    this.intlMsg = new IntlMsg(props.intl, 'login');
    this.handleReactivate = this.handleReactivate.bind(this);
  }

  componentWillMount() {
    const { logout } = this.props;
    logout();
  }

  componentWillReceiveProps(nextProps) {
    const { authed, auth, gotoOverview, reactivated } = nextProps;
    if (authed) {
      gotoOverview();
    }

    if (auth.error) {
      this.setState({
        error: auth.error,
      });
      if (auth.error.code === 'ACCINACTIVE') {
        this.setState({ showReactivate: true });
      }
    }

    if (reactivated !== this.props.reactivated) {
      this.setState({ reactivated });
    }
  }

  check() {
    const { username, password } = this.state;
    if (username === '') {
      this.setState({
        error: 'FE_EMAILEMPTY',
      });
      return false;
    }
    if (password === '') {
      this.setState({
        error: 'FE_PASSWORDEMPTY',
      });
      return false;
    }
    return true;
  }

  handleSubmit(e) {
    e.preventDefault();
    this.setState({
      error: null,
      reactivated: {},
    });
    if (!this.check()) {
      return;
    }

    const { login } = this.props;
    const { username, password } = this.state;
    login(username, password);
  }

  handleReactivate() {
    const { reactivate } = this.props;
    const { username } = this.state;
    reactivate(username);
  }

  render() {
    const { gotoRegister, gotoLostPassword } = this.props;
    const {
      error,
      username,
      password,
      reactivated,
      showReactivate = false,
    } = this.state;

    return (
      <div styleName="wrapper" style={{ minHeight: window.innerHeight }}>
        <div
          styleName="login"
          className={`animated ${error ? 'shake' : ''}`}
        >
          <h1> {this.intlMsg.msg('title')} </h1>
          <Form onSubmit={e => this.handleSubmit(e)}>
            <FormGroup validationState={error ? 'error' : undefined}>
              <InputGroup bsClass="aisz-input-group aisz-input-group-o">
                <InputGroup.Addon><i className="fa fa-user" /></InputGroup.Addon>
                <FormControl
                  autoFocus
                  bsClass="aisz-form-control-o"
                  type="text"
                  placeholder={this.intlMsg.msg('email.placeholder')}
                  value={username}
                  onChange={e => this.setState({
                    username: e.target.value,
                    inactive: false,
                    error: null,
                  })}
                />
              </InputGroup>
            </FormGroup>
            <FormGroup validationState={error ? 'error' : undefined}>
              <InputGroup bsClass="aisz-input-group aisz-input-group-o">
                <InputGroup.Addon><i className="fa fa-unlock-alt" /></InputGroup.Addon>
                <FormControl
                  bsClass="aisz-form-control-o"
                  type="password"
                  placeholder={this.intlMsg.msg('password.placeholder')}
                  value={password}
                  onChange={e => this.setState({ password: e.target.value })}
                />
              </InputGroup>
            </FormGroup>
            <Collapse in={!isNil(error)}>
              <FormGroup>
                <div className="text-center" styleName="login-error">
                  <span className="halflings halflings-warning-sign" />
                  {' '}
                  {this.intlMsg.errorMsg(error)}
                </div>
                <ShowIf if={showReactivate}>
                  <HideIf if="profile:cube">
                    <div className="text-center">
                      <RichButton
                        status={reactivated.status || ''}
                        states={[{
                          status: 'default',
                          label: <span>{this.intlMsg.msg('reactivate')}</span>,
                          style: 'link',
                          onClick: this.handleReactivate,
                        }, {
                          status: 'success',
                          label: <span>{this.intlMsg.msg('reactivate.success')}</span>,
                          style: 'link-success',
                        }, {
                          status: 'failure',
                          label: <span>{this.intlMsg.msg('reactivate.failure')}</span>,
                          style: 'link-danger',
                          onClick: this.handleReactivate,
                        }, {
                          status: 'pending',
                          style: 'link-default',
                          label: <span><i className="fa fa-spinner fa-spin" />{' '}{this.intlMsg.msg('reactivate.pending')}</span>,
                        }]}
                      />
                    </div>
                  </HideIf>
                </ShowIf>
              </FormGroup>
            </Collapse>
            <FormGroup>
              <Button bsStyle="aisz-primary-o" bsSize="large" type="submit">
                { this.intlMsg.msg('button') }
                {' '}
                <span className="halflings halflings-log-in" />
              </Button>
            </FormGroup>
          </Form>
          <HideIf if="profile:cube">
            <div styleName="login-links" >
              <div styleName="links">
                <Link onClick={gotoRegister}>
                  <FormattedMessage id="login.signup" />
                </Link>
                <Link onClick={gotoLostPassword}>
                  <FormattedMessage id="login.forgetpwd" />
                </Link>
              </div>
            </div>
          </HideIf>
        </div>
      </div>
    );
  }
}

Login.propTypes = propTypes;

const mapStateToProps = state => ({
  authed: state.auth.authed,
  auth: state.auth,
  reactivated: state.account.reactivate,
});

const mapDispatchToProps = dispatch => ({
  logout: () => dispatch(authActions.revoke()),
  login: (username, password) => dispatch(authActions.token(username, password)),
  reactivate: email => dispatch(accountActions.reactivate(email)),
  gotoOverview: () => dispatch(push('/overview')),
  gotoRegister: () => dispatch(push('/register?ref=lora')),
  gotoLostPassword: () => dispatch(push('/lostpassword?ref=lora')),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  injectIntl(CSSModules(Login, styles, { allowMultiple: true })));




// WEBPACK FOOTER //
// ./src/containers/Login/index.jsx